const data = [
  {
    title: 'Spend more quality time with friends, family and the kids',
    image: 'graphicBurst5',
  },
  {
    title: 'Learn new skills',
    image: 'graphicBurst6',
  },
  {
    title: 'Try new or special experiences',
    image: 'graphicBurst7',
  },
  {
    title: 'Treat friends and family',
    image: 'graphicBurst8',
  },
  {
    title: 'Get to know your local community',
    image: 'graphicBurst9',
  },
  {
    title: 'There’s something for everyone',
    image: 'graphicBurst13',
  },
];

export default data;
